module.exports = "https://trybtryb-legacy.web.app/img/happy-holidays.0955dc76.webp";